import {styledByTheme} from "../../../themes/architecture/styled-by-theme";
import {MainWrapperDefaultBox} from "./main-wrapper.default.box";
import { MainWrapperCipBox } from "./main-wrapper.cip.box";
import { MainWrapperMrGreenCisBox } from "./main-wrapper.mrgreenCis.box";

export const MainWrapperBox = styledByTheme(MainWrapperDefaultBox)
    .forCip(MainWrapperCipBox)
    .forMrGreenCis(MainWrapperMrGreenCisBox)
    .apply();
